import React from "react"
import { Modal, Button } from "components/common"
import { toast } from "react-toastify";
import PropTypes from 'prop-types'
import { useDispatch } from "react-redux";
import { useDropzone } from "react-dropzone";
import { FaCloudUploadAlt, FaTrash, FaCheckCircle } from "react-icons/fa";
import { changeAvatar } from "redux/authorization/userSlice";

const UserDetailChangeAvatar = ({showModal, setshowModal, user}) => {
  const [avatar, setAvatar] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(false);
  const dispatch = useDispatch();

  const {getInputProps, getRootProps, isDragActive} = useDropzone({
    accept: "image/*",
    onDrop: acceptedFiles => {
      setAvatar(
        acceptedFiles.map(file =>
          Object.assign(file, {
            preview: URL.createObjectURL(file)
          })
        )
      );
    }
  })

  const handleRemove = () => {
    setAvatar([]);
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    const formData = new FormData()
    formData.append('avatar', avatar[0])

    try {
      if (user)
      {
        setIsLoading(true);
        const userId = user.id
        dispatch(changeAvatar({userId, formData})).then(() => {
          setshowModal(false);
          setAvatar([]);
          setIsLoading(false);
        }).catch((error) => {
          setIsLoading(false);
          toast.error(error.message || 'Failed to change avatar');
        });
      }
    }
    catch(error) {
      setIsLoading(false);
      console.log(error.message)
      toast.error(error.message)
    }
  }

  const handleCancel = () => {
    setshowModal(false)
  }

  return (
    <>
      <Modal
        show={showModal}
        onHide={() => setshowModal(false)}
        backdropClick={false}
        size="lg"
        title="Change Avatar"
        footer={
          <>
            <Button variant="secondary" onClick={handleCancel} disabled={isLoading}>Cancel</Button>
            <Button variant="primary" onClick={handleSubmit} disabled={avatar.length === 0 || isLoading}>
              {isLoading ? '⏳ Uploading...' : '✓ Upload Avatar'}
            </Button>
          </>
        }
      >
        <form onSubmit={handleSubmit}>
          {avatar && avatar.length === 0 ? (
            <div
              {...getRootProps({
                className: isDragActive ? 'dropzone-area-active' : 'dropzone-area'
              })}
              style={{
                border: `2px dashed ${isDragActive ? '#667eea' : '#d0d0d0'}`,
                borderRadius: '0.75rem',
                padding: '3rem 2rem',
                textAlign: 'center',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                backgroundColor: isDragActive ? 'rgba(102, 126, 234, 0.08)' : 'rgba(102, 126, 234, 0.02)',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.borderColor = '#667eea';
                e.currentTarget.style.backgroundColor = 'rgba(102, 126, 234, 0.08)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.borderColor = '#d0d0d0';
                e.currentTarget.style.backgroundColor = 'rgba(102, 126, 234, 0.02)';
              }}
            >
              <input {...getInputProps({multiple:false})} />
              <div style={{ marginBottom: '1rem' }}>
                <FaCloudUploadAlt style={{ fontSize: '3rem', color: '#667eea', marginBottom: '1rem' }} />
              </div>
              <h6 className="tw-font-bold tw-mb-2" style={{ color: '#333' }}>
                {isDragActive ? 'Drop your avatar here' : 'Drop avatar here or click to select'}
              </h6>
              <p className="tw-text-gray-500" style={{ fontSize: '0.875rem' }}>
                Supported formats: JPG, PNG, GIF, WebP<br />
                Maximum file size: 5MB
              </p>
            </div>
          ) : (
            <div style={{ textAlign: 'center' }}>
              <div style={{
                display: 'inline-block',
                position: 'relative',
                marginBottom: '1.5rem',
                borderRadius: '1rem',
                overflow: 'hidden',
                border: '3px solid #667eea'
              }}>
                <img
                  width={200}
                  height={200}
                  src={avatar && avatar.length > 0 ? avatar[0]?.preview : null}
                  alt="avatar preview"
                  style={{ objectFit: 'cover' }}
                />
                <div style={{
                  position: 'absolute', top: '8px', right: '8px',
                  background: '#28a745', borderRadius: '50%', padding: '0.5rem', color: 'white'
                }}>
                  <FaCheckCircle style={{ fontSize: '1.2rem' }} />
                </div>
              </div>
              <p className="tw-text-gray-500 tw-mb-3" style={{ fontSize: '0.875rem' }}>{avatar[0]?.name}</p>
              <button
                type="button"
                onClick={handleRemove}
                className="tw-text-red-600 tw-font-bold tw-bg-transparent tw-border-0 tw-cursor-pointer tw-flex tw-items-center tw-gap-1 tw-mx-auto"
              >
                <FaTrash className="tw-mr-1" /> Remove Avatar
              </button>
              <div style={{ marginTop: '1.5rem', padding: '1rem', backgroundColor: 'rgba(102, 126, 234, 0.05)', borderRadius: '0.5rem' }}>
                <p className="tw-text-gray-500 tw-mb-0" style={{ fontSize: '0.85rem' }}>
                  💡 This is your new avatar. Click "Upload" to confirm the change.
                </p>
              </div>
            </div>
          )}
        </form>
      </Modal>
    </>
  ) 
}

UserDetailChangeAvatar.propTypes = {
  showModal: PropTypes.bool.isRequired,
  setshowModal: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired
}

export default UserDetailChangeAvatar